<template>
  <div>
    clinical tools editor
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>